import { render, staticRenderFns } from "./addNotice.vue?vue&type=template&id=3d84bfd3&scoped=true&"
import script from "./addNotice.vue?vue&type=script&lang=js&"
export * from "./addNotice.vue?vue&type=script&lang=js&"
import style0 from "./addNotice.vue?vue&type=style&index=0&id=3d84bfd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d84bfd3",
  null
  
)

export default component.exports